import { useQuery } from '@tanstack/react-query';
import { AlertOctagon } from 'lucide-react';
import { api } from '@/lib/api';

export function MistakeCounts() {
  const q = useQuery({ queryKey: ['mistakes'], queryFn: api.mistakes });
  const counts = q.data?.counts ?? {};
  const entries = Object.entries(counts).sort((a, b) => b[1] - a[1]);
  const total = entries.reduce((a, [, n]) => a + n, 0);

  return (
    <div className="rounded-xl border border-zinc-800 bg-zinc-950 p-4">
      <div className="flex items-center gap-2 mb-2">
        <AlertOctagon className="size-4 text-amber-400" />
        <h3 className="text-sm font-medium text-zinc-200">Mistake ledger</h3>
        <span className="text-[11px] text-zinc-400 ml-auto">{total} tagged</span>
      </div>
      {entries.length === 0 ? (
        <p className="text-xs text-zinc-400 py-3 text-center">
          No mistakes tagged yet. Use the post-mortem tagger on the History page.
        </p>
      ) : (
        <ul className="space-y-1">
          {entries.map(([tag, n]) => (
            <li key={tag} className="flex items-center justify-between text-xs">
              <span className="text-zinc-300 capitalize">{tag.replace('-', ' ')}</span>
              <div className="flex items-center gap-2">
                <div className="w-24 h-1.5 bg-zinc-900 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-rose-500/70"
                    style={{ width: `${(n / total) * 100}%` }}
                  />
                </div>
                <span className="num text-zinc-200 w-6 text-right">{n}</span>
              </div>
            </li>
          ))}
        </ul>
      )}
      <p className="text-[10px] text-zinc-400 mt-2 leading-snug">
        Track recurring mistakes to break loops. The cardinal sins (FOMO, broke
        stop, over-sized) compound — naming them is half the cure.
      </p>
    </div>
  );
}
